export * from './delete-bewertungs-anlass.service';
export * from './delete-bewertungs-anlass.service.module';